import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=b4e9de74&scoped=true&"
import script from "./FormData.vue?vue&type=script&lang=js&"
export * from "./FormData.vue?vue&type=script&lang=js&"
import style0 from "./FormData.vue?vue&type=style&index=0&id=b4e9de74&prod&lang=scss&"
import style1 from "./FormData.vue?vue&type=style&index=1&id=b4e9de74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e9de74",
  null
  
)

export default component.exports